import styled from '@emotion/styled';

const Wrapper = styled.div`
  margin-left: 10px;
`;

export {
  Wrapper
};
